import { initEasasJs } from "core/DynamicComponentLoader";
import "./style/style"
import 'react-tooltip/dist/react-tooltip.css';
import {getBuildId, isProd} from "utils/utils";

console.log("EASAS-JS main bundle entry point...")
console.log("EASAS-JS is running in " + (isProd() ? "production" : "development") + " mode")
console.log("Auto CD Build ID: " + getBuildId())

initEasasJs();

if (module.hot) {
    console.log("Accepting hot reload...")
    module.hot.accept();
}
